import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import mutations from './mutations'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {
    fusionAuthToken: null,
    isShopManager: false,
    isCustomerService: false,
    isAdmin: false,
    isOctipasAdmin: false,
    currentGroup: null,
    currentStore: null,
    currentStoreDetails: null,
    currentTab: null,
    drawer: true,
    mini: false,
    loading: false,
    roles: null,
    rolesUnifiedStock: 'store-stock-viewer',
    rolesOctiStock: 'default-seller',
    rolesAnalytics: 'seller',
    previousPath: null,
    partnerSettings: null,
    userEmail: null,
    username: null,
    isDark: false,
    breadcrumbs: [],
    userStores: [],
    aiEnabled: false,
    partnerTheme: {},
    currentTheme: {},
    displayNavigation: true,
    documentSettings: null,
    // Set the default locale based on the browser's language
    locale: navigator.language.substring(0, 2),
  },
  mutations,
  actions,
  plugins: [
    createPersistedState({
      // Authorization caches must not outlive the tab: stale documentSettings could
      // grant access on a since-revoked configuration after a hard reload.
      reducer: (state) => {
        const persisted = { ...state }
        delete persisted.documentSettings
        return persisted
      },
    }),
  ],
})

export default store
